import Details from "./Details";
import Main from "./Main";



export default { Details, Main }